import React from "react"

import { Dialog } from "@mui/material"
import T from "prop-types"

export const Backdrop = ({ isOpen }) => <Dialog open={isOpen} />

Backdrop.propTypes = {
  isOpen: T.bool,
}
